"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledErrorMessage = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _excluded = ["children"];

var IconError = function IconError(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentcolor"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 16H0V0h16v16zm-9-5v2h2v-2H7zm0-8v6h2V3H7z"
  }));
};

var StyledIconError = /*#__PURE__*/(0, _styledComponents["default"])(IconError).withConfig({
  displayName: "ErrorMessage__StyledIconError",
  componentId: "sc-1gohwmx-0"
})(["margin-right:", ";vertical-align:text-top;fill:", ";"], function (p) {
  return p.theme.tokens.spacing03;
}, function (p) {
  return p.theme.tokens.colorError;
});

var StyledErrorMessage = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  displayName: "ErrorMessage__StyledErrorMessage",
  componentId: "sc-1gohwmx-1"
})(["font-weight:", ";color:", ";margin:", " 0 ", " 0;"], function (p) {
  return p.theme.tokens.fontWeightBold;
}, function (p) {
  return p.theme.tokens.colorError;
}, function (p) {
  return p.theme.tokens.spacing03;
}, function (p) {
  return p.theme.tokens.spacing06;
});

exports.StyledErrorMessage = StyledErrorMessage;

var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledErrorMessage, props, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    as: StyledIconError
  }), children);
};

ErrorMessage.propTypes = {
  children: _propTypes.node
};
var _default = ErrorMessage;
exports["default"] = _default;